import { client } from '@/apolloClient'
import {
  UtilitiesDocument,
  UtilitiesQuery,
  UtilitiesQueryVariables,
} from '@/generated/graphql'
import * as Sentry from '@sentry/browser'

type FetchViewConfigVariables = Omit<
  UtilitiesQueryVariables,
  'utilityProgramIdInt' | 'utilityProgramId'
> & {
  utilityProgramId: number | string | undefined
}

export async function fetchViewConfigFromCMS(
  variables: FetchViewConfigVariables,
) {
  if (variables.utilityProgramId == null) {
    return null
  }
  const utilityProgramId = String(variables.utilityProgramId)
  const result = await client.query<UtilitiesQuery>({
    query: UtilitiesDocument,
    variables: {
      ...variables,
      utilityProgramId,
      utilityProgramIdInt: Number(variables.utilityProgramId),
    },
  })

  // If there are any errors in the result, capture them using Sentry
  if (result.error || result.errors) {
    Sentry.captureException(result.error ?? result.errors)
  }

  const resolvedGroupViewConfig = result.data.resolvedGroupViewConfig
  const utilityProgram = result.data.utilityProgram

  if (!resolvedGroupViewConfig) {
    return resolvedGroupViewConfig
  }

  return {
    ...resolvedGroupViewConfig,
    sponsorName: utilityProgram?.sponsorName ?? resolvedGroupViewConfig.name,
  } as typeof resolvedGroupViewConfig & { sponsorName?: string }
}
